import React from "react";

const MyToolbarLeft = ({ children }) => {
  return <div>{children}</div>;
};

export default MyToolbarLeft;
